// extracted by mini-css-extract-plugin
export var gif = "_bx-0";